export const getTransitRating = (score) => {
  if (score === 0) return 'Score not available';
  if (score < 50) return 'Some transit';
  if (score < 70) return 'Good transit';
  return 'Excellent transit';
};

export const getDiversityRating = (score) => {
  if (score < 50) return 'Slightly diverse';
  if (score < 70) return 'Moderately diverse';
  return 'Very Walkable';
};
